import { ParsedUrlQuery } from 'querystring';

export function getBuyerIncentive(query: ParsedUrlQuery) {
    if (query['buyer_incentive']) {
        return query['buyer_incentive'];
    }

    return '';
}
